import React from "react";
import { BackButton, NextButton } from "@tripbuilder/common/custom/Buttons";

interface NavigationButtonsProps {
  currentStep: number;
  handleBack: () => void;
  handleNext: () => void;
  isLastStep: boolean;
}

const NavigationButtons: React.FC<NavigationButtonsProps> = ({
  currentStep,
  handleBack,
  handleNext,
  isLastStep,
}) => {
  return (
    <div className="flex justify-between items-center">
      {currentStep > 0 ? (
        <BackButton onClick={handleBack} />
      ) : (
        <div></div> // Empty div to maintain spacing
      )}
      <NextButton
        onClick={handleNext}
        isLastStep={isLastStep}
        className={`${currentStep === 0 ? "ml-auto" : ""}`}
      />
    </div>
  );
};

export default NavigationButtons;
